import * as React from 'react'
import { ReactComponent as MemberHelpColdFormed } from '../icons/MemberHelpColdFormed.svg'
import { ReactComponent as MemberHelpMetalDeck } from '../icons/MemberHelpMetalDeck.svg'
import { ReactComponent as MemberHelpRectHollow } from '../icons/MemberHelpRectHollow.svg'
import { ReactComponent as MemberHelpRectSolid } from '../icons/MemberHelpRectSolid.svg'
import { ReactComponent as MemberHelpRoundHollow } from '../icons/MemberHelpRoundHollow.svg'
import { ReactComponent as MemberHelpRoundSolid } from '../icons/MemberHelpRoundSolid.svg'
import { ReactComponent as MemberHelpWideFlange } from '../icons/MemberHelpWideFlange.svg'
import { ReactComponent as MemberHelpZee } from '../icons/MemberHelpZee.svg'

import { Box } from '@mui/material'
import { memberKind } from '../internalModules'

type Props = {
  kind: string
}

export default function UIMemberDialogGraphics({kind}: Props) {
  const imageSize = 400

  function showMemberGraphic(){
    switch (kind) {
      case memberKind.solidRect:
        return <MemberHelpRectSolid height={imageSize}/>
      case memberKind.hollowRect:
        return <MemberHelpRectHollow height={imageSize}/>
      case memberKind.coldFormed:
        return <MemberHelpColdFormed height={imageSize}/>
      case memberKind.wideFlange:
        return <MemberHelpWideFlange height={imageSize}/>
      case memberKind.metalDeck:
        return <MemberHelpMetalDeck height={imageSize}/>
      case memberKind.solidRound:
        return <MemberHelpRoundSolid height={imageSize}/>
      case memberKind.hollowRound:
        return <MemberHelpRoundHollow height={imageSize}/>
      case memberKind.zee:
        return <MemberHelpZee height={imageSize}/>
      default:
        return <></>
    }
  }

  return(
    <Box marginBottom={4} display='flex' justifyContent='center' alignItems='center'>
      {showMemberGraphic()}
    </Box>
  )
}